import { createContext, useContext } from "react";

export const MaterialRequestContext = createContext<any>({});

export const PointingDetailsContext = createContext<any>({});
export const ContraryReserveDetailsContext = createContext<any>({});

export const OperationFoldersContext = createContext<any>({});

/**
 * CREATE CONTEXT FOR OPERATION TYPE ( SALES OPERATION OR CABOTAGE OPERATION )
 */

export type OperationType = "sales" | "cabotage" | "unknown";

export const OperationTypeContext = createContext<OperationType>("unknown");

export const useOperationType = () => useContext(OperationTypeContext);

/**
 * END OF CONTEXT CREATION FOR OPERATION TYPE
 */